import { FC } from 'react';
import { PreloadedQuery, usePreloadedQuery } from 'react-relay';
import graphql from 'babel-plugin-relay/macro';

import NotFound from 'components/NotFound';
import EntityEditPageSkeleton from 'components/EntityEditPageSkeleton';
import Tabber from 'components/Tabber';
import ServiceEditVariants from 'components/ServiceEditVariants';
import PageWithSidebar from 'components/PageWithSidebar';
import EntitySidebar from 'components/EntitySidebar';
import ServiceEditForm from 'components/ServiceEditForm';

import { withData } from 'lib';
import { SettingsServiceEditPageQuery } from '__generated__/SettingsServiceEditPageQuery.graphql';

const query = graphql`
  query SettingsServiceEditPageQuery($id: ID!) {
    service(id: $id) {
      name

      group {
        id
        name
      }

      ...EntitySidebar_entity
      ...ServiceEditForm_service
      ...ServiceEditVariants_service
    }
  }
`;

type RouteParams = {
  id: string;
};

type Props = {
  preloadedQuery: PreloadedQuery<SettingsServiceEditPageQuery>;
};

const breadcrumbs = [
  { link: '/settings', name: 'Nustatymai' },
  {
    link: '/settings/service-groups',
    name: 'Papildomų paslaugų paketai',
  },
];

const SettingsServiceEditPage: FC<Props> = ({ preloadedQuery }) => {
  const { service } = usePreloadedQuery<SettingsServiceEditPageQuery>(
    query,
    preloadedQuery
  );

  if (!service) {
    return <NotFound />;
  }

  return (
    <PageWithSidebar
      sidebar={<EntitySidebar entity={service} />}
      breadcrumbs={[
        ...breadcrumbs,
        {
          link: `/settings/service-groups/${service.group.id}#services`,
          name: service.group.name,
        },
        { name: service.name },
      ]}>
      <Tabber
        tabs={[
          {
            title: 'Bendra informacija',
            component: <ServiceEditForm service={service} />,
            hash: 'main',
          },
          {
            title: 'Variantai',
            component: <ServiceEditVariants service={service} />,
            hash: 'options',
          },
        ]}
      />
    </PageWithSidebar>
  );
};

export default withData<SettingsServiceEditPageQuery, RouteParams>({
  query,
  loading: <EntityEditPageSkeleton breadcrumbs={breadcrumbs} />,

  variables: ({ routeParams }) => ({
    id: routeParams.id,
  }),
})(SettingsServiceEditPage);
